import { Injectable } from '@angular/core';
import { LocalStoreService } from './local-store.service';
import { Subscription } from 'rxjs';
import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client';
import { environment } from '../../../environments/environment';
import { Person } from '../../state/models/person';


@Injectable({
  providedIn: 'root'
})
export class AmplitudeExperimentsService {
  identifyEvent: any;
  subscribe: Subscription;
  experiment: ExperimentClient;
  experimentFetch: ExperimentClient;
  APP_USER = 'EGRET_USER';

  constructor(
    private ls: LocalStoreService) {
    this.experiment = Experiment.initializeWithAmplitudeAnalytics(
      environment.amplitudeExperimentsClient, {}
    );

  }

  async init() {
    this.experimentFetch = await this.experiment.fetch({
      user_id: this.getUser()?.id?.toString(),
    });
  }

  getUser() {
    return this.ls.getItem(this.APP_USER) as Person;
  }

    getHomeOld(): boolean {
    return this.experimentFetch?.variant('nova-home-e-exames-vs-antiga')?.value === 'controle-telas-antigas';
  }

  getHomeNew(): boolean {
    return this.experimentFetch?.variant('nova-home-e-exames-vs-antiga')?.value === 'experimento-telas-novas';
  }


}
